export default "__VITE_ASSET__dVhGNK57__"